/* Library */
import React, { Component } from "react";
import Link from "../../../../../components/ZUILib/Link";
import InputButton from "../../../../../components/ZUILib/InputButton";
import commonUtil from "../../../../../utils/commonUtil";
import * as typeActions from "../../actions";

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const { initiateEventCloseProcess } = typeActions;

export default class TemporaryClosingModel extends Component {
  constructor() {
    super();
    this.state = {
      initiateEventCloseProcessErrorMessage: null,
    };
  }
  onAcceptClick = () => {
    if(this.props.isInitialClosure){
    initiateEventCloseProcess(this.props.eventId)
      .then((response) => {
        if (response.body.status && response.body.status.status === 'success') {
          this.props.temporaryModal();
        } else {
          this.setState({
            initiateEventCloseProcessErrorMessage:
              (response && response.body && response.body.errorMessage) ||
              'Ocurrió un error inesperado. Por favor, intenta de nuevo más tarde.',
          });
        }
      })
      .catch((e) => {
        console.log(e); // console required
        this.setState({
          initiateEventCloseProcessErrorMessage:
            (e && e.body && e.body.errorMessage) ||
            'Ocurrió un error inesperado. Por favor, intenta de nuevo más tarde.',
        });
      });
    }else{
      this.props.temporaryModal();
    }
  };
  render() {
    const errorAncher = {
      cssClass: "icon-tache2",
      onClickHandler: () => {
        this.setState({ initiateEventCloseProcessErrorMessage: null });
      },
    };
    const Aceptar = {
      type: "button",
      value: "Continuar",
      autoFocus: false,
      cssStyle: {
        borderRadius: "4px",
      },
      style: "btnPrimary size-Full closeButtonClassWAP",
      onClickHandler: this.onAcceptClick,
    };
    const Cancelar = {
      id: "closeModal",
      type: "button",
      value: "Cancelar",
      autoFocus: false,
      style: "btnDelete size-Full",
    };

    const webCloseLbl = {
      color: "#333333",
    };

    const wapCloseLbl = {
      paddingTop: "3%",
      color: "#333333",
    };

    return (
      <div className="row gift-summary-temporary-close-modal-row">
        <div className="col-md-12 gift-summary-temporary-close-modal-colmd">
          {this.state.initiateEventCloseProcessErrorMessage ? (
            <div className="alertError">
              <i className="icon-tache2" />
              <p>{this.state.initiateEventCloseProcessErrorMessage}</p>
              <Link linkJSON={errorAncher} />
            </div>
          ) : null}
          <p style={channel === constChannels.WEB ? webCloseLbl : wapCloseLbl}>
            Al iniciar el cierre de la mesa no podrán comprarte regalos ni hacer
            cambios por 5 minutos.
          </p>
          <p
            style={{ paddingTop: "1%", paddingBottom: "6%", color: "#333333" }}
          >
            ¿Estás seguro que deseas continuar?
          </p>
          {channel === constChannels.WEB ? (
            <div
              className="row"
              style={{
                paddingTop: "1rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className="col-md-4 col-sm-4 text-center">
                <InputButton buttonAttr={Aceptar}>
                  <i className="icon-flecha_gruesa_abajo" />
                </InputButton>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-md-4 text-center">
                <InputButton buttonAttr={Aceptar}>
                  <i className="icon-flecha_gruesa_abajo" />
                </InputButton>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
